import { DocumentumUploadResponse, DownloadDocumentumParams, UploadDocumentumParams } from '@/interfaces/documents';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DocumentumService {

  constructor(
    private http: HttpClient,
  ) { }

  uploadFile(params: UploadDocumentumParams): Observable<number> {
    const formData = new FormData();
    formData.append('file', params.fileToUpload, params.name);
    formData.append('driverMdmid', params.mdmid);
    formData.append('requirementId', `${params.requirementId}`);
    formData.append('documentRequiredType', `${params.documentId}`);
    formData.append('assetId', `${params.assetId}`);

    return this.http.post<DocumentumUploadResponse>(
      `/File/UploadBase64/DocumentRequiredType/${params.documentId}`,
      formData,
    ).pipe(
      map((response: DocumentumUploadResponse) => (
        response.id
      )),
    );
  }

  downloadDocumentFile(params: DownloadDocumentumParams): Observable<Blob> {
    const stringParams = Object.keys(params).reduce<Record<string, string>>((obj, key) => {
      // eslint-disable-next-line no-param-reassign
      obj[key] = `${(params as any)[key]}`;
      return obj;
    }, {});
    return this.http.get('/File/Download/Search', {
      responseType: 'blob',
      params: stringParams,
    });
  }

}
